const componentDefinitions = {
    anime: {
        selector: '[uc-anime], [data-uc-anime]',
        load: () => import(
            /* webpackChunkName: "unicore-anime" */ '../uni-core/js/components/anime.min.js'
        ),
    },
    filter: {
        selector: '[uc-filter], [data-uc-filter]',
        load: () => import(
            /* webpackChunkName: "unicore-filter" */ '../uni-core/js/components/filter.min.js'
        ),
    },
    lightbox: {
        selector: '[uc-lightbox], [data-uc-lightbox]',
        load: () => import(
            /* webpackChunkName: "unicore-lightbox" */ '../uni-core/js/components/lightbox.min.js'
        ),
    },
    notification: {
        load: () => import(
            /* webpackChunkName: "unicore-notification" */ '../uni-core/js/components/notification.min.js'
        ),
    },
    parallax: {
        selector: '[uc-parallax], [data-uc-parallax]',
        load: () => import(
            /* webpackChunkName: "unicore-parallax" */ '../uni-core/js/components/parallax.min.js'
        ),
    },
    slider: {
        selector: '[uc-slider], [data-uc-slider]',
        load: () => import(
            /* webpackChunkName: "unicore-slider" */ '../uni-core/js/components/slider.min.js'
        ),
    },
    sliderParallax: {
        selector: '[uc-slider-parallax], [data-uc-slider-parallax]',
        dependencies: ['slider'],
        load: () => import(
            /* webpackChunkName: "unicore-slider-parallax" */ '../uni-core/js/components/slider-parallax.min.js'
        ),
    },
    slideshow: {
        selector: '[uc-slideshow], [data-uc-slideshow]',
        load: () => import(
            /* webpackChunkName: "unicore-slideshow" */ '../uni-core/js/components/slideshow.min.js'
        ),
    },
    slideshowParallax: {
        selector: '[uc-slideshow-parallax], [data-uc-slideshow-parallax]',
        dependencies: ['slideshow'],
        load: () => import(
            /* webpackChunkName: "unicore-slideshow-parallax" */ '../uni-core/js/components/slideshow-parallax.min.js'
        ),
    },
    sortable: {
        selector: '[uc-sortable], [data-uc-sortable]',
        load: () => import(
            /* webpackChunkName: "unicore-sortable" */ '../uni-core/js/components/sortable.min.js'
        ),
    },
    tooltip: {
        selector: '[uc-tooltip], [data-uc-tooltip]',
        load: () => import(
            /* webpackChunkName: "unicore-tooltip" */ '../uni-core/js/components/tooltip.min.js'
        ),
    },
    upload: {
        selector: '[uc-upload], [data-uc-upload]',
        load: () => import(
            /* webpackChunkName: "unicore-upload" */ '../uni-core/js/components/upload.min.js'
        ),
    },
};

const componentPromises = new Map();

const instantiateComponent = (name, selector) => {
    if (!selector || typeof window.UniCore[name] !== 'function') {
        return;
    }

    document.querySelectorAll(selector).forEach((element) => {
        if (!window.UniCore.getComponents(element)[name]) {
            window.UniCore[name](element);
        }
    });
};

export const loadUniCoreComponent = (name) => {
    const definition = componentDefinitions[name];

    if (!definition) {
        return Promise.reject(new Error(`Unknown UniCore component: ${name}`));
    }

    if (!componentPromises.has(name)) {
        const dependencies = definition.dependencies || [];
        const promise = Promise.all(dependencies.map(loadUniCoreComponent))
            .then(definition.load)
            .then(() => {
                instantiateComponent(name, definition.selector);
                return window.UniCore[name];
            });

        componentPromises.set(name, promise);
    }

    return componentPromises.get(name);
};

const containsComponent = (root, selector) => {
    if (!(root instanceof Element)) {
        return false;
    }

    return root.matches(selector) || root.querySelector(selector);
};

const loadComponentsIn = (root) => {
    Object.entries(componentDefinitions).forEach(([name, definition]) => {
        if (definition.selector && containsComponent(root, definition.selector)) {
            loadUniCoreComponent(name);
        }
    });
};

loadComponentsIn(document.documentElement);

new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(loadComponentsIn);
    });
}).observe(document.documentElement, {
    childList: true,
    subtree: true,
});

window.loadUniCoreComponent = loadUniCoreComponent;
